<template>
	<div >
		<div style="padding: 0 220px;">
			<div class="nodea" v-if="count.length == 0">
				<img src="../../../../assets/img/nodata.png" >
			</div>
			<div class="list_box" v-for="(item, index) in count" @click="goDeatils(i,item.id)" :key="index" >
				<div class="two-overflow type_size_22" >
					<span >{{item.question_title }}</span>
				
				</div>
				<div class="p_m_t_20" v-if=' i ==0'>
					{{item.jobSubmit.job_name}}
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20" v-show="i == 0">
					<div class="p_flex type_size_16">
						<span class="subject_color">{{item.classLevel.name}}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{item.subject_def}}</span>
					</div>
					<div class="p_flex"><el-button type="success" size="mini">去批改</el-button></div>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20" v-show="i == 1">
					<div class="p_flex p_f_1 one-overflow p_m_r_30">{{item.jobSubmit.job_name}}</div>
					<div class="p_flex type_size_16">
						<span class="subject_color">{{item.classLevel.name}}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{item.student.name}}</span>
					</div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue'
export default {
	data() {
		return {
			count: [],
			loading: false,
			num:0,
			type:this.i
		};
	},
	props: {
		i: {
			type: Number,
			default() {
				return 0;
			}
		}
	},
	components:{
		pagination
	},
	created(){
		this.get()
	},
	mounted() {},
	methods: {
		get(id) {
			this.$request.ajax(this).post("/api_teacher/wrong_question_list",{
				wrong_correct_status: this.type == 0?2:1, //1.待批改，2.已订正
				page:id?id:1,	// 第几页
				limit:10   // 每页显示
			}).then(res=>{
				this.count=res.data.list
				this.num=parseInt(res.data.count)
			})
		},
		getInfo( i){
			this.type = i
			this.get()
		},
		goDeatils(i,id){
			this.$router.push({
				path: '/WrongDetails',
				query:{
					type:i,
					job_record_id:id
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
.type_size_22 {
	line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/wrong/commponents/wrongList.vue